import UserPermissionComponent from "../components/UserPermission";
import useUserPermission from "../hooks/useUserPermission";

function UserPermission() {
  const useUserPermissionProps = useUserPermission();
  return <UserPermissionComponent {...useUserPermissionProps} />;
}

export default UserPermission;
